import React from 'react'
import { useLazyGetAllBoardCommitteeApprovalListQuery } from '../services/BoardCommitteeApproval/BoardCommitteeServiceApi';


/**
 * Custom hook for fetching board committee list.
 * 
 * @returns {{
 *   fetchBoardCommitteeList: (params: { memberId: Number, taskListId: Number }) => void,
 *   boardCommitteeListData: Array,
 *   isBoardCommitteeListLoading: boolean,
 *   isBoardCommitteeListSuccess: boolean,
 *   isBoardCommitteeListError: boolean,
 *   boardCommitteeListError: any,
 * }}
 */
export const useGetBoardCommitteeList = () => {

    const [triggerApi, apiState] = useLazyGetAllBoardCommitteeApprovalListQuery();

    // Return aliases for state properties
    return {
        fetchBoardCommitteeList: triggerApi,
        boardCommitteeListData: apiState.data,
        isBoardCommitteeListLoading: apiState.isLoading,
        isBoardCommitteeListSuccess: apiState.isSuccess,
        isBoardCommitteeListError: apiState.isError,
        boardCommitteeListError: apiState.error,
    }
}
